module.exports = __webpack_public_path__ + "static/media/rotulo_weiss.efc68568.png";